(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  var observer = null;
  var initQueue = [];
  var flushScheduled = false;

  function flushQueue() {
    flushScheduled = false;
    var el = initQueue.shift();
    if (!el) return;
    if (!el.classList.contains('pc-carousel-init') && typeof Swiper !== 'undefined') {
      el.classList.add('pc-carousel-init');
      el.swiperInstance = new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: el.dataset.loop === 'true',
        watchOverflow: true
      });
    }
    if (initQueue.length) scheduleFlush();
  }

  function scheduleFlush() {
    if (flushScheduled) return;
    flushScheduled = true;
    window.requestAnimationFrame(flushQueue);
  }

  function queueInit(el) {
    if (el.classList.contains('pc-carousel-init') || initQueue.indexOf(el) !== -1) return;
    initQueue.push(el);
    scheduleFlush();
  }

  function getObserver() {
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            queueInit(entry.target);
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '200px 0px' });
    }
    return observer;
  }

  function observeCarousels(root) {
    if (!mq.matches) return;
    (root || document).querySelectorAll('.pc-mobile-carousel:not(.pc-carousel-init)').forEach(function (el) {
      getObserver().observe(el);
    });
  }

  function destroyCarousel(el) {
    if (el.swiperInstance) {
      el.swiperInstance.destroy(true, false);
      el.swiperInstance = null;
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    observeCarousels();
  });

  document.addEventListener('shopify:section:load', function (e) {
    observeCarousels(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('.pc-mobile-carousel').forEach(destroyCarousel);
  });

  if (mq.addEventListener) {
    mq.addEventListener('change', function () {
      if (mq.matches) observeCarousels();
    });
  } else if (mq.addListener) {
    mq.addListener(function () {
      if (mq.matches) observeCarousels();
    });
  }

  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('.pc-mobile-carousel')) {
          if (mq.matches) getObserver().observe(node);
        } else if (node.querySelectorAll) {
          observeCarousels(node);
        }
      });
      m.removedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('.pc-mobile-carousel')) {
          destroyCarousel(node);
        } else if (node.querySelectorAll) {
          node.querySelectorAll('.pc-mobile-carousel').forEach(destroyCarousel);
        }
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
